import { render, staticRenderFns } from "./ontick-tier-icon.component.vue?vue&type=template&id=1865ed64"
import script from "./ontick-tier-icon.component.vue?vue&type=script&lang=js"
export * from "./ontick-tier-icon.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports